import Vue from 'vue'

var goBackS = new Vue({})
export default goBackS;


// WEBPACK FOOTER //
// ./src/page/index/goBackS.js